import {
  Landmark,
  BarChart3,
  Users,
  Workflow,
  Home,
  NotebookPen,
  Handshake,
  FolderKanban,
} from "lucide-react";
import { useContext, useState } from "react";
import { GlobalContext } from "../context/Context";

const Organization = (
  <svg
    width="32"
    height="30"
    viewBox="0 0 32 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8999 18.8181L12.9092 18.8181"
      stroke="#222222"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6333 18.8181L16.6426 18.8181"
      stroke="#222222"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 21.6818C4.5 22.1881 4.69667 22.6737 5.04673 23.0317C5.3968 23.3897 5.8716 23.5908 6.36667 23.5908L19.4333 23.5908C19.9284 23.5908 20.4032 23.3897 20.7533 23.0317C21.1033 22.6737 21.3 22.1881 21.3 21.6818L21.3 11.659C21.3001 11.5734 21.2777 11.4893 21.235 11.4156C21.1924 11.3419 21.1312 11.2813 21.0578 11.2401C20.9844 11.1989 20.9016 11.1787 20.8179 11.1815C20.7342 11.1843 20.6528 11.2101 20.5823 11.2562L16.4177 13.9709C16.3472 14.017 16.2658 14.0428 16.1821 14.0456C16.0984 14.0485 16.0156 14.0282 15.9422 13.987C15.8688 13.9458 15.8076 13.8852 15.765 13.8115C15.7223 13.7378 15.6999 13.6537 15.7 13.5681L15.7 11.659C15.7001 11.5734 15.6777 11.4893 15.635 11.4156C15.5924 11.3419 15.5312 11.2813 15.4578 11.2401C15.3844 11.1989 15.3016 11.1787 15.2179 11.1815C15.1342 11.1843 15.0528 11.2101 14.9823 11.2562L10.8187 13.9709C10.7481 14.0172 10.6666 14.0433 10.5828 14.0462C10.499 14.0492 10.4159 14.029 10.3424 13.9878C10.2688 13.9465 10.2075 13.8858 10.1649 13.812C10.1222 13.7381 10.0998 13.6539 10.1 13.5681L10.1 8.31812C10.1 7.81179 9.90333 7.32621 9.55327 6.96818C9.2032 6.61016 8.7284 6.40903 8.23333 6.40903L6.36667 6.40903C5.8716 6.40903 5.3968 6.61016 5.04673 6.96818C4.69667 7.32621 4.5 7.81179 4.5 8.31812L4.5 21.6818Z"
      stroke="#222222"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g filter="url(#filter0_d_615_24404)" data-figma-bg-blur-radius="1.9">
      <path
        d="M12.5 16.0606C12.5 16.5026 12.6717 16.9266 12.9773 17.2391C13.2829 17.5517 13.6974 17.7273 14.1296 17.7273L25.537 17.7273C25.9692 17.7273 26.3837 17.5517 26.6894 17.2391C26.995 16.9266 27.1667 16.5026 27.1667 16.0606L27.1667 7.31061C27.1667 7.23586 27.1472 7.16246 27.11 7.09812C27.0728 7.03377 27.0193 6.98085 26.9553 6.94489C26.8912 6.90893 26.8188 6.89126 26.7458 6.89373C26.6727 6.8962 26.6017 6.91873 26.5401 6.95894L22.9044 9.32894C22.8428 9.36915 22.7717 9.39168 22.6987 9.39415C22.6256 9.39662 22.5533 9.37895 22.4892 9.34299C22.4251 9.30703 22.3717 9.25411 22.3345 9.18976C22.2973 9.12542 22.2777 9.05202 22.2778 8.97727L22.2778 7.31061C22.2779 7.23586 22.2583 7.16246 22.2211 7.09812C22.1839 7.03377 22.1304 6.98085 22.0664 6.94489C22.0023 6.90893 21.9299 6.89126 21.8569 6.89373C21.7838 6.8962 21.7128 6.91873 21.6512 6.95894L18.0163 9.32894C17.9547 9.36937 17.8835 9.39208 17.8104 9.39466C17.7372 9.39725 17.6647 9.37962 17.6005 9.34364C17.5363 9.30765 17.4828 9.25463 17.4455 9.19016C17.4083 9.12569 17.3887 9.05215 17.3889 8.97727L17.3889 4.39394C17.3889 3.95191 17.2172 3.52799 16.9116 3.21543C16.606 2.90287 16.1915 2.72727 15.7593 2.72727L14.1296 2.72727C13.6974 2.72727 13.2829 2.90287 12.9773 3.21543C12.6717 3.52799 12.5 3.95191 12.5 4.39394L12.5 16.0606Z"
        fill="#FF4086"
        fillOpacity="0.3"
        shapeRendering="crispEdges"
      />
    </g>
    <path
      d="M9.1665 18.8181L9.17584 18.8181"
      stroke="#222222"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_615_24404"
        x="10.6"
        y="0.827274"
        width="20.6665"
        height="22"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="1.05" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_615_24404"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_615_24404"
          result="shape"
        />
      </filter>
      <clipPath
        id="bgblur_0_615_24404_clip_path"
        transform="translate(-10.6 -0.827274)"
      >
        <path d="M12.5 16.0606C12.5 16.5026 12.6717 16.9266 12.9773 17.2391C13.2829 17.5517 13.6974 17.7273 14.1296 17.7273L25.537 17.7273C25.9692 17.7273 26.3837 17.5517 26.6894 17.2391C26.995 16.9266 27.1667 16.5026 27.1667 16.0606L27.1667 7.31061C27.1667 7.23586 27.1472 7.16246 27.11 7.09812C27.0728 7.03377 27.0193 6.98085 26.9553 6.94489C26.8912 6.90893 26.8188 6.89126 26.7458 6.89373C26.6727 6.8962 26.6017 6.91873 26.5401 6.95894L22.9044 9.32894C22.8428 9.36915 22.7717 9.39168 22.6987 9.39415C22.6256 9.39662 22.5533 9.37895 22.4892 9.34299C22.4251 9.30703 22.3717 9.25411 22.3345 9.18976C22.2973 9.12542 22.2777 9.05202 22.2778 8.97727L22.2778 7.31061C22.2779 7.23586 22.2583 7.16246 22.2211 7.09812C22.1839 7.03377 22.1304 6.98085 22.0664 6.94489C22.0023 6.90893 21.9299 6.89126 21.8569 6.89373C21.7838 6.8962 21.7128 6.91873 21.6512 6.95894L18.0163 9.32894C17.9547 9.36937 17.8835 9.39208 17.8104 9.39466C17.7372 9.39725 17.6647 9.37962 17.6005 9.34364C17.5363 9.30765 17.4828 9.25463 17.4455 9.19016C17.4083 9.12569 17.3887 9.05215 17.3889 8.97727L17.3889 4.39394C17.3889 3.95191 17.2172 3.52799 16.9116 3.21543C16.606 2.90287 16.1915 2.72727 15.7593 2.72727L14.1296 2.72727C13.6974 2.72727 13.2829 2.90287 12.9773 3.21543C12.6717 3.52799 12.5 3.95191 12.5 4.39394L12.5 16.0606Z" />
      </clipPath>
    </defs>
  </svg>
);

const useNav = () => {
  let { state } = useContext(GlobalContext);

  const [navList, setNavList] = useState({
    asideNav: [
      {
        name: "Home",
        icon: <Home size="1em" />,
        url: "",
        activeKey: "dashboards",
      },
      {
        name: "Leads",
        icon: <Users size="1em" />,
        url: "",
        activeKey: "leads",
      },
      {
        name: "Accounts",
        icon: <NotebookPen size="1em" />,
        url: "",
        activeKey: "accounts",
      },
      {
        name: "Deals",
        icon: <Handshake size="1em" />,
        url: "",
        activeKey: "deals",
      },
      {
        name: "Projects",
        icon: <FolderKanban size="1em" />,
        url: "",
        activeKey: "projects",
      },
      {
        name: "Activity",
        icon: <FolderKanban size="1em" />,
        url: "",
        activeKey: "activity",
      },
      {
        name: "Logs",
        icon: <FolderKanban size="1em" />,
        url: "",
        activeKey: "logs",
      },
    ].filter(Boolean),

    LeadsTopHeader: [
      {
        name: "My Leads",
        icon: Organization,
        url: "/leads/my-leads/overview",
        activeKey: "my-leads",
      },
      {
        name: "My Team",
        icon: Organization,
        url: "/leads/team/overview",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/leads/organization/overview",
        activeKey: "organization",
      },
    ].filter(Boolean),

    LeadsBottomHeader: [
      {
        name: "Overview",
        url: "/leads/my-leads/overview",
        activeKey: "overview",
      },
      { name: "My Leads", url: "/leads/my-leads/lead", activeKey: "lead" },
    ].filter(Boolean),

    LeadsTeamBottomHeader: [
      { name: "Overview", url: "/leads/team/overview", activeKey: "overview" },
      { name: "Team Leads", url: "/leads/team/lead", activeKey: "lead" },
    ].filter(Boolean),

    LeadsOrgBottomHeader: [
      {
        name: "Overview",
        url: "/leads/organization/overview",
        activeKey: "overview",
      },
      { name: "All Leads", url: "/leads/organization/lead", activeKey: "lead" },
      { name: "Recycled Leads", url: "/leads/organization/recycled-leads", activeKey: "recycled-leads" },
    ].filter(Boolean),

    WalletsBottomHeader: [
      { name: "Wallets", url: "/walltes/wallet/:id", activeKey: "wallet" },
    ].filter(Boolean),

    WalletsTopHeader: [
      {
        name: "Wallets",
        icon: Organization,
        url: "/walltes/wallet/:id",
        activeKey: "wallet",
      },
    ].filter(Boolean),

    DashbaoardTopHeader: [
      {
        name: "Dashboard",
        icon: Organization,
        url: "/dashboard/overview",
        activeKey: "dashboard",
      },
    ].filter(Boolean),

    DashbaoardBottomHeader: [
      { name: "Overview", url: "/dashboard/overview", activeKey: "overview" },
      { name: "Team", url: "/dashboard/my-team", activeKey: "my-team" },
      {
        name: "Organization",
        url: "/dashboard/organization",
        activeKey: "organization",
      },
    ].filter(Boolean),

    DevicesBottomHeader: [
      { name: "Devices", url: "/devices/device", activeKey: "device" },
    ].filter(Boolean),

    DevicesTopHeader: [
      {
        name: "Devices",
        icon: Organization,
        url: "/devices/device",
        activeKey: "device",
      },
    ].filter(Boolean),

    OperationsTopHeader: [
      {
        name: "Clients",
        icon: Organization,
        url: "/operations/client/overview",
        activeKey: "client",
      },
      {
        name: "Agents",
        icon: Organization,
        url: "/operations/agents/overview",
        activeKey: "agents",
      },
      {
        name: "Teams",
        icon: Organization,
        url: "/operations/team/overview",
        activeKey: "team",
      },
      {
        name: "Brands",
        icon: Organization,
        url: "/operations/brand/overview",
        activeKey: "brand",
      },
      {
        name: "Products",
        icon: Organization,
        url: "/operations/product/product-list",
        activeKey: "product",
      },
      {
        name: "Packages",
        icon: Organization,
        url: "/operations/package/overview",
        activeKey: "package",
      },
      {
        name: "Merchants",
        icon: Organization,
        url: "/operations/merchant/overview",
        activeKey: "merchant",
      },
      {
        name: "Lost Deals Reasons",
        icon: Organization,
        url: "/operations/lost-deals/lost-deal",
        activeKey: "lost-deals",
      },
    ].filter(Boolean),

    AgentsBottomHeader: [
      {
        name: "Overview",
        url: "/operations/agents/overview",
        activeKey: "overview",
      },
      {
        name: "Agent",
        url: "/operations/agents/agent-list",
        activeKey: "agent-list",
      },
    ].filter(Boolean),

    AgentsTopHeader: [
      {
        name: "Agents",
        icon: Organization,
        url: "/agents/agent",
        activeKey: "agent",
      },
    ].filter(Boolean),

    brandsBottomHeader: [
      {
        name: "Overview",
        url: "/operations/brand/overview",
        activeKey: "overview",
      },
      {
        name: "Brand",
        url: "/operations/brand/brand-list",
        activeKey: "brand-list",
      },
    ].filter(Boolean),

    brandsTopHeader: [
      {
        name: "Brands",
        icon: Organization,
        url: "/brands/brand",
        activeKey: "brand",
      },
    ].filter(Boolean),

    packagesBottomHeader: [
      {
        name: "Overview",
        url: "/operations/package/overview",
        activeKey: "overview",
      },
      {
        name: "Package",
        url: "/operations/package/package-list",
        activeKey: "package-list",
      },
    ].filter(Boolean),

    packagesTopHeader: [
      {
        name: "Packages",
        icon: Organization,
        url: "/packages/package",
        activeKey: "package",
      },
    ].filter(Boolean),

    merchantsBottomHeader: [
      {
        name: "Overview",
        url: "/operations/merchant/overview",
        activeKey: "overview",
      },
      {
        name: "Merchant",
        url: "/operations/merchant/merchant-list",
        activeKey: "merchant-list",
      },
      {
        name: "Merchant Type",
        url: "/operations/merchant/merchant-type",
        activeKey: "merchant-type",
      },
    ].filter(Boolean),

    merchantsTopHeader: [
      {
        name: "Merchants",
        icon: Organization,
        url: "/merchants/merchant",
        activeKey: "merchants",
      },
    ].filter(Boolean),

    lostDealsBottomHeader: [
      {
        name: "Lost Deal Reason",
        url: "/operations/lost-deal",
        activeKey: "lost-deal",
      },
    ].filter(Boolean),

    lostDealsTopHeader: [
      {
        name: "Lost Deals Reasons",
        icon: Organization,
        url: "/lost-deals/lost-deal",
        activeKey: "lost-deal",
      },
    ].filter(Boolean),

    usersBottomHeader: [
      {
        name: "Overview",
        url: "/operations/client/overview",
        activeKey: "overview",
      },
      {
        name: "Clients",
        url: "/operations/client/client-list",
        activeKey: "client-list",
      },
    ].filter(Boolean),

    usersTopHeader: [
      {
        name: "Clients",
        icon: Organization,
        url: "/clients/client",
        activeKey: "client",
      },
    ].filter(Boolean),

    productsBottomHeader: [
      // {
      //   name: "Overview",
      //   url: "/operations/product/overview",
      //   activeKey: "overview",
      // },
      {
        name: "Product",
        url: "/operations/product/product-list",
        activeKey: "product-list",
      },
      {
        name: "Category",
        url: "/operations/product/category-list",
        activeKey: "category-list",
      },
      {
        name: "Package",
        url: "/operations/product/package-list",
        activeKey: "package-list",
      },
    ].filter(Boolean),

    productsTopHeader: [
      {
        name: "Products",
        icon: Organization,
        url: "/products/product",
        activeKey: "product",
      },
    ].filter(Boolean),

    teamsBottomHeader: [
      {
        name: "Overview",
        url: "/operations/team/overview",
        activeKey: "overview",
      },
      {
        name: "Team",
        url: "/operations/team/team-list",
        activeKey: "team-list",
      },
    ].filter(Boolean),

    teamsTopHeader: [
      {
        name: "Teams",
        icon: Organization,
        url: "/teams/team",
        activeKey: "team",
      },
    ].filter(Boolean),

    SettingsBottomHeader: [
      { name: "Settings", url: "/settings/setting", activeKey: "setting" },
    ].filter(Boolean),

    SettingsTopHeader: [
      {
        name: "Company Settings",
        icon: Organization,
        url: "/settings/setting",
        activeKey: "settings",
      },
    ].filter(Boolean),

    LeadDetailBottomHeader: [
      {
        name: "Lead Details",
        url: "/leads/leadDetail/:id",
        activeKey: "leadDetail",
      },
    ].filter(Boolean),

    DealDetailBottomHeader: [
      {
        name: "Deal Details",
        url: "/deals/dealDetail/:id",
        activeKey: "dealDetail",
      },
    ].filter(Boolean),

    ProjectDetailBottomHeader: [
      {
        name: "Project Details",
        url: "/projects/projectDetail/:key",
        activeKey: "projectDetail",
      },
    ].filter(Boolean),

    BrandsTopHeader: [
      {
        name: "Brands",
        icon: Organization,
        url: "/brands/brand",
        activeKey: "brands",
      },
    ].filter(Boolean),

    asideNav2: [
      {
        name: "Operations",
        icon: <Workflow size="1em" />,
        url: "",
        activeKey: "oprations",
        role: "1 2 3",
      },
      {
        name: "Reports",
        icon: <BarChart3 size="1em" />,
        url: "",
        activeKey: "organization-reports",
        role: "1 2 3",
      },
    ].filter(Boolean),

    topHeaderNav: [
      { name: "My Space", icon: Organization, url: "", activeKey: "my-space" },
      { name: "Team", icon: Organization, url: "", activeKey: "team" },
      {
        name: "Organization",
        icon: <Landmark size="1em" />,
        url: "/organization/employee-directory",
        activeKey: "organization",
      },
    ].filter(Boolean),

    topAccountNav: [
      {
        name: "Accounts",
        icon: Organization,
        url: "/accounts/account/overview",
        activeKey: "account",
      },
      {
        name: "Team",
        icon: Organization,
        url: "/accounts/team/overview",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/accounts/organization/overview",
        activeKey: "organization",
      },
    ].filter(Boolean),

    accountBottomNav: [
      {
        name: "Overview",
        url: "/accounts/account/overview",
        activeKey: "overview",
      },
      {
        name: "Account",
        url: "/accounts/account/account-list",
        activeKey: "account-list",
      },
    ].filter(Boolean),

    accountTeamBottomNav: [
      {
        name: "Overview",
        url: "/accounts/team/overview",
        activeKey: "overview",
      },
      {
        name: "Account",
        url: "/accounts/team/account-list",
        activeKey: "account-list",
      },
    ].filter(Boolean),

    accountOrgBottomNav: [
      {
        name: "Overview",
        url: "/accounts/organization/overview",
        activeKey: "overview",
      },
      {
        name: "Account",
        url: "/accounts/organization/account-list",
        activeKey: "account-list",
      },
    ].filter(Boolean),

    accountDetailBottomNav: [
      {
        name: "Account Details",
        url: "/accounts/account-details/:id",
        activeKey: "account-details",
      },
    ].filter(Boolean),

    topActivityNav: [
      {
        name: "Follow Ups",
        icon: Organization,
        url: "/activites/activity/overview",
        activeKey: "activity",
      },
      {
        name: "Team",
        icon: Organization,
        url: "/activites/team/overview",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/activites/organization/overview",
        activeKey: "organization",
      },
    ].filter(Boolean),

    activityBottomNav: [
      {
        name: "Overview",
        url: "/activites/activity/overview",
        activeKey: "overview",
      },
      {
        name: "Follow Ups",
        url: "/activites/activity/activity-list",
        activeKey: "activity-list",
      },
    ].filter(Boolean),

    activityTeamBottomNav: [
      {
        name: "Overview",
        url: "/activites/team/overview",
        activeKey: "overview",
      },
      {
        name: "Follow Ups",
        url: "/activites/team/activity-list",
        activeKey: "activity-list",
      },
    ].filter(Boolean),

    activityOrgBottomNav: [
      {
        name: "Overview",
        url: "/activites/organization/overview",
        activeKey: "overview",
      },
      {
        name: "Follow Ups",
        url: "/activites/organization/activity-list",
        activeKey: "activity-list",
      },
    ].filter(Boolean),

    saleTopNav: [
      {
        name: "Sales",
        icon: Organization,
        url: "/sales/sale/overview",
        activeKey: "sale",
      },
      {
        name: "Team",
        icon: Organization,
        url: "/sales/team/overview",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/sales/organization/overview",
        activeKey: "organization",
      },
    ].filter(Boolean),

    saleBottomNav: [
      { name: "Overview", url: "/sales/sale/overview", activeKey: "overview" },
      { name: "Sales", url: "/sales/sale/sale-list", activeKey: "sale-list" },
      {
        name: "Assigned Sales",
        url: "/sales/sale/assigned-sale-list",
        activeKey: "assigned-sale-list",
      },
    ].filter(Boolean),

    saleTeamBottomNav: [
      { name: "Overview", url: "/sales/team/overview", activeKey: "overview" },
      {
        name: "Sales",
        url: "/sales/team/sale-list",
        activeKey: "activity-list",
      },
      {
        name: "Assigned Sales",
        url: "/sales/team/assigned-sale-list",
        activeKey: "assigned-sale-list",
      },
    ].filter(Boolean),

    saleOrgBottomNav: [
      {
        name: "Overview",
        url: "/sales/organization/overview",
        activeKey: "overview",
      },
      {
        name: "Sales",
        url: "/sales/organization/sale-list",
        activeKey: "sale-list",
      },
      {
        name: "Assigned Sales",
        url: "/sales/organization/assigned-sale-list",
        activeKey: "assigned-sale-list",
      },
    ].filter(Boolean),

    topLogNav: [
      {
        name: "Activity",
        icon: Organization,
        url: "/logs/log",
        activeKey: "logs",
      },
    ].filter(Boolean),

    topProjectNav: [
      {
        name: "Projects",
        icon: Organization,
        url: "/projects/project",
        activeKey: "projects",
      },
    ].filter(Boolean),

    topTaskNav: [
      {
        name: "Tasks",
        icon: Organization,
        url: "/tasks/overview",
        activeKey: "tasks",
      },
    ].filter(Boolean),

    taskBottomNav: [
      { name: "Overview", url: "/tasks/overview", activeKey: "overview" },
      { name: "My Task", url: "/tasks/my-task", activeKey: "my-task" },
    ].filter(Boolean),

    mySpaceBottomNav: [
      { name: "Overview", url: "", activeKey: "overview" },
      { name: "Dashboard", url: "", activeKey: "dashboard" },
      { name: "Calendar", url: "", activeKey: "calendar" },
    ].filter(Boolean),

    contactDetailBottomNav: [
      {
        name: "Contact Details",
        url: "/contacts/contact-details/:id",
        activeKey: "contact-details",
      },
    ].filter(Boolean),

    logsBottomNav: [
      { name: "Activity", url: "/logs/log", activeKey: "log" },
    ].filter(Boolean),

    topRefundNav: [
      {
        name: "Organization",
        icon: Organization,
        url: "/refunds/organization/refund",
        activeKey: "organization",
      },
    ].filter(Boolean),

    refundOrgBottomNav: [
      {
        name: "Overview",
        url: "/refunds/organization/overview",
        activeKey: "overview",
      },

      {
        name: "List",
        url: "/refunds/organization/refund",
        activeKey: "refund",
      },
      {
        name: "By Department",
        url: "/refunds/organization/report-by-department",
        activeKey: "report-by-department",
      },
      {
        name: "By Sales Agent",
        url: "/refunds/organization/report-by-sales-agent",
        activeKey: "report-by-sales-agent",
      },

      {
        name: "By Product",
        url: "/refunds/organization/report-by-product",
        activeKey: "report-by-product",
      },
      {
        name: "By Brand",
        url: "/refunds/organization/report-by-brand",
        activeKey: "report-by-brand",
      },
      {
        name: "By Source",
        url: "/refunds/organization/report-by-source",
        activeKey: "report-by-source",
      },
      {
        name: "By Merchant",
        url: "/refunds/organization/report-by-merchant",
        activeKey: "report-by-merchant",
      },
      {
        name: "By Account Manager",
        url: "/refunds/organization/report-by-account-manager",
        activeKey: "report-by-account-manager",
      },
      {
        name: "By Team Lead",
        url: "/refunds/organization/report-by-team-lead",
        activeKey: "report-by-team-lead",
      },
    ].filter(Boolean),

    brandBottomNav: [
      { name: "Brand", url: "/brands/brand", activeKey: "brand" },
    ].filter(Boolean),

    topDealNav: [
      {
        name: "Deals",
        icon: Organization,
        url: "/deals/deal/overview",
        activeKey: "deal",
      },
      {
        name: "My Team",
        icon: Organization,
        url: "/deals/team/overview",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/deals/organization/overview",
        activeKey: "organization",
      },
    ].filter(Boolean),

    dealBottomNav: [
      { name: "Overview", url: "/deals/deal/overview", activeKey: "overview" },
      {
        name: "Deal List",
        url: "/deals/deal/deal-list",
        activeKey: "deal-list",
      },
    ].filter(Boolean),

    dealOrgBottomNav: [
      {
        name: "Overview",
        url: "/deals/organization/overview",
        activeKey: "overview",
      },
      {
        name: "Deal List",
        url: "/deals/organization/deal-list",
        activeKey: "deal-list",
      },
    ].filter(Boolean),

    dealTeamBottomNav: [
      { name: "Overview", url: "/deals/team/overview", activeKey: "overview" },
      {
        name: "Deal List",
        url: "/deals/team/deal-list",
        activeKey: "deal-list",
      },
    ].filter(Boolean),

    projectBottomNav: [
      { name: "Project", url: "/projects/project", activeKey: "project" },
    ].filter(Boolean),

    organizationBottomNav: [
      { name: "Overview", url: "", activeKey: "overview" },
      { name: "Announcements", url: "", activeKey: "announcements" },
      { name: "Policies", url: "", activeKey: "policies" },
      { name: "Employee Tree", url: "", activeKey: "employee-tree" },
      { name: "Department Tree", url: "", activeKey: "department-tree" },
      {
        name: "Employee Directory",
        url: "employee-directory",
        activeKey: "employee-directory",
      },
      { name: "Birthday Folks", url: "", activeKey: "birthday-folks" },
      { name: "New Hires", url: "", activeKey: "new-hires" },
    ].filter(Boolean),

    // System Settings
    systemSettingsBottomHeader: [
      {
        name: "Setting List",
        url: "/system-settings",
        activeKey: "system-settings",
      },
    ].filter(Boolean),

    systemSettingsTopHeader: [
      {
        name: "System Settings",
        icon: Organization,
        url: "/system-settings",
        activeKey: "system-settings",
      },
    ].filter(Boolean),

    // Lead Status
    leadStatusBottomHeader: [
      {
        name: "Lead Status",
        url: "/lead-status",
        activeKey: "lead-status",
      },
    ].filter(Boolean),

    leadStatusTopHeader: [
      {
        name: "Lead Status",
        icon: Organization,
        url: "/lead-status",
        activeKey: "lead-status",
      },
    ].filter(Boolean),

    // client Renewal Status
    clientRenewalsBottomHeader: [
      {
        name: "Renewals Tracker",
        url: "/renewals-tracker",
        activeKey: "renewals-tracker",
      },
    ].filter(Boolean),

    clientRenewalsTopHeader: [
      {
        name: "Renewals Tracker",
        icon: Organization,
        url: "/renewals-tracker",
        activeKey: "renewals-tracker",
      },
    ].filter(Boolean),

    clientHealthBottomHeader: [
      {
        name: "Health Score Factor",
        url: "/client-health/health-score-factor",
        activeKey: "health-score-factor",
      },
      {
        name: "Health Score Thresholds",
        url: "/client-health/health-score-thresholds",
        activeKey: "health-score-thresholds",
      },
      {
        name: "Priority Flags",
        url: "/client-health/priority-flags",
        activeKey: "priority-flags",
      },
    ].filter(Boolean),

    clientHealthTopHeader: [
      {
        name: "Client Health",
        icon: Organization,
        url: "/client-health/health-score-factor",
        activeKey: "client-health",
      },
    ].filter(Boolean),
  });

  const checkCondi = state?.user?.dashboardRole === "single";

  console.log("checkCondi", checkCondi, state?.user?.dashboardRole);

  // const allowKeys = ["DashbaoardTopHeader", "DashbaoardBottomHeader"];
  const allowKeys = ["", ""];

  const finalNavList = checkCondi
    ? Object.fromEntries(
        Object.entries(navList).map(([key, navArray]) => [
          key,
          navArray.map((item) => ({
            ...item,
            url: allowKeys.includes(key) ? item.url : "",
          })),
        ])
      )
    : navList;

  // console.log("finalNavList", finalNavList);

  return finalNavList;
};

export default useNav;
